import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {User} from '../../Interfaces/User';
import {Subscription} from 'rxjs';
import {AppComponent} from '../../app.component';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {NavItem} from '../../Interfaces/NavItem';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {SharedVarService} from '../shared-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {

  myForm: UntypedFormGroup;
  myUser = {} as User;
  errorFound: boolean = false;
  phoneApp: boolean = false;
  submitted = false;
  subscription: Subscription;
  errorOut: string;
  noUser: boolean = false; foundUser=false; showLogin = true;
  @ViewChild("username1") userField: ElementRef;
  myMenus : NavItem[] = [];
  myAccount : NavItem;
  myHelp : NavItem;
  clientRequest: ClientRequest;
  activePass: boolean = true;


  constructor(fb: UntypedFormBuilder, private router: Router,private  queryService: QueryService, public myApp:AppComponent, private  globalEventsManager: GlobalEventsManager, private shared: SharedVarService) {
    this.myForm = fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]});
  }

  ngOnInit() {
    this.showLogin = true;

    if (window.innerWidth <= 760){
      this.phoneApp = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.userField.nativeElement.focus());
  }

  showPassword(){
    if (this.activePass){
      this.activePass = false;
    }else{
      this.activePass = true;
    }
  }


  signUp(){
    this.router.navigate(["newuser"]);
  }

  forgot(){
    this.router.navigate(["forgot"]);
  }

  login() : void {

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.myUser.username = this.myForm.controls.username.value;
    this.myUser.password = this.myForm.controls.password.value;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.submitted = true;
    this.errorFound = false;
    this.noUser= false;
      if (this.myForm.valid) {
        const lhsUserObs$ = this.queryService.loginUser(this.clientRequest);
        this.subscription = lhsUserObs$.subscribe(
          (lhsUser) => {
            this.myUser = lhsUser;
          },
          error => {
            if (error.status == "401") {
            } else {
              this.myApp.openDialog(error.message)
            }
          },
          () => {
            if (this.myUser.maherError == null) {
              if (this.myUser.navisErrors != null){
                this.errorFound = true;
                //this.errorOut = this.myUser.navisErrors[0];
                this.errorOut = "There was a problem with your login credentials. Please try again."

              }else{
                this.foundUser = true;
                this.showLogin = false;
                this.submitted = false;
                this.globalEventsManager.showLogin.emit(false);
                this.globalEventsManager.userObj.emit(this.myUser);
                localStorage.setItem("user", this.myUser.username);
                this.globalEventsManager.theirName.emit(this.myUser.first_name + ' ' + this.myUser.last_name);
                this.globalEventsManager.role.emit(this.myUser.company_code + ' ' + this.myUser.company_name);
                this.router.navigate([""]);
                this.myForm.reset();
                this.getAllMenus();
              }
            }else{
                this.errorFound = true;
//                this.errorOut = this.myUser.maherError;
              this.errorOut = "There was a problem with your login credentials. Please try again."


            }

          });
      }
    //  }
  }

  get f() { return this.myForm.controls;}


  private getAllMenus(){

    const lhsUserObs2$ = this.queryService.getMenus(this.clientRequest);
    this.subscription = lhsUserObs2$.subscribe(
      (lhsMenu) => {
        this.myMenus = lhsMenu;},
      error=> {
        if (error.status=="401"){
        }else{
          this.myApp.openDialog(error.message)
        }
      },
      ()=> {
        if (this.myMenus[0].children.length>0 && this.myMenus[0].children[0].displayName.toString().includes("NO_DATA_FOUND")){
          this.myMenus = [];
          this.globalEventsManager.navItems.emit(this.myMenus);
        }else {
          if (!this.phoneApp){
            var indx = this.myMenus.findIndex(xx => xx.displayName == 'My Account');
            if (indx != -1) {
              this.myAccount = this.myMenus[indx];
              this.myMenus.splice(indx, 1);
            }
            indx = this.myMenus.findIndex(xx => xx.displayName == 'Help');
            if (indx != -1) {
              this.myHelp = this.myMenus[indx];
              this.myMenus.splice(indx, 1);
            }
          }

          if (this.phoneApp){
            for (var upper of this.myMenus){
                  upper.children = upper.children.filter(xx=> xx.mobile == "1");
            }
          }





          this.globalEventsManager.navItems.emit(this.myMenus);
          this.globalEventsManager.myAccount.emit(this.myAccount);
          this.globalEventsManager.myHelp.emit(this.myHelp);

          if (this.myUser.role=='MISC' && this.myUser.company_code=='M0995'){
            this.router.navigate(["driverhome"]);
          }else{
            this.router.navigate(["charts"]);
          }


      //    }else{
      //      this.router.navigate(["menus"]);

      //    }
        }

      });
  }


}
